import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ConfigService } from 'src/app/services/config.service';
import { LocaleService } from 'src/app/services/locale.service';
import { ToastService } from '../../_core/services/toast.service';

@Component({
  selector: 'app-logout',
  templateUrl: 'logout.component.html',
  styleUrls: ['logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  private readonly toastService = inject(ToastService);

  constructor(
    authService: AuthService,
    userService: UserService,
    configService: ConfigService,
    localeService: LocaleService,
    router: Router
  ) {
    const idToken = userService.getIdToken();

    authService.logout().subscribe(
      () => {
        userService.resetUserData();
        sessionStorage.removeItem('userConfig');
        localStorage.removeItem('viewMode');

        const _location = (window as any).location;
        let customLogout = configService.get().customLogoutUrl;

        if (idToken) {
          const param = customLogout.includes('?') ? '&' : '?';
          customLogout = `${customLogout}${param}id_token_hint=${idToken}`;
        }

        if (customLogout) {
          _location.href = customLogout;
        } else {
          _location.href = '/';
        }
      },
      () => {
        router.navigate(['/']).then(() => this.toastService.showToast('messages.error.unknown', 'error'));
      }
    );
  }

  ngOnInit() {}
}
